import axios from "axios";
import { API_Base_URL } from "./Config";

const instance = axios.create({
	baseURL: API_Base_URL,
	headers: { "Content-Type": "application/json" },
});

export default instance;
